'use client';

import { ArrowRightIcon } from '@phosphor-icons/react/dist/ssr';
import { LogoutButton } from '@/features/auth/logout-button';
import { Button } from '@/shared/ui/core';
import { RequiredDataNote } from '@/shared/ui/kit/required-data-note';
import {
    RegistrationCard, RegistrationCardContent, RegistrationCardDescription, RegistrationCardHeader,
    RegistrationCardTitle,
} from '@/shared/ui/layout/registration-card';
import { useCompanyStep } from '../../lib/use-company-step';
import { CompanySubForm } from './step-profile/company-sub-form';
import { WizardFooterSplit } from '../wizard-footer-split';
import styles from './step-company.module.scss';


export const StepCompanySplit = () => {
    const { companyRef, handleNext, state } = useCompanyStep();

    return (
        <div data-template="step-company">
            <RegistrationCard data-template="registration-steps-card">
                <RegistrationCardHeader data-template="registration-steps-card-header">
                    <RegistrationCardTitle data-template="registration-steps-card-title">
                        {
                            'Hello{{name}}! Tell us about your company'.replace(
                                '{{name}}',
                                state.data.profile?.first_name ? (', ' + state.data.profile.first_name) : '',
                            )
                        }
                    </RegistrationCardTitle>

                    <RegistrationCardDescription data-template="registration-steps-card-description">
                        We need your company details to set up your own plan.
                    </RegistrationCardDescription>
                </RegistrationCardHeader>

                <RegistrationCardContent data-template="registration-steps-card-content">
                    <div className={ styles.grid }>
                        <CompanySubForm
                            ref={ companyRef }
                            defaultValues={ state.data.company }
                            onSubmit={ () => undefined }
                        />
                    </div>
                </RegistrationCardContent>
            </RegistrationCard>

            <WizardFooterSplit
                state={ state }
                left={
                    <div className={ styles.footer_left }>
                        <LogoutButton variant='secondary'/>
                        <RequiredDataNote className={ styles.required }/>
                    </div>
                }
                right={
                    <Button
                        onClick={ handleNext }
                        leftIcon={ <ArrowRightIcon/> }
                    >
                        Continue
                    </Button>
                }
            />
        </div>
    );
};
